function customSelectInit (){
  document.querySelectorAll('[js-custom-option-select]').forEach(function(selectElement) {
        var numberOfOptions = selectElement.children.length;
        var optionName = selectElement.dataset.optionName;
        if (optionName) {
            optionName = optionName + ' : ';
        } else {
            optionName = '';
        }
   
        selectElement.style.display = 'none';
   
        var wrapper = document.createElement('div');
        wrapper.className = 'select';
        selectElement.parentNode.insertBefore(wrapper, selectElement);
        wrapper.appendChild(selectElement);
   
        var styledSelect = document.createElement('div');
        styledSelect.className = 'select-styled';
        var selectedText = selectElement.querySelector('option[selected]') ?
            selectElement.querySelector('option[selected]').textContent :
            selectElement.options[selectElement.selectedIndex].textContent;
   
        styledSelect.innerHTML = `${optionName}${selectedText}<div class="select-styled-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M14.6665 4.66602L7.99984 11.3327L1.33317 4.66602" stroke="white" stroke-width="1.5" stroke-linecap="square"/>
            </svg></div>`;
           
        wrapper.appendChild(styledSelect);
   
        var list = document.createElement('ul');
        list.className = 'select-options';
        wrapper.appendChild(list);
   
        for (var i = 0; i < numberOfOptions; i++) {
            var listItem = document.createElement('li');
            listItem.textContent = selectElement.children[i].textContent;
            listItem.setAttribute('rel', selectElement.children[i].value);
            list.appendChild(listItem);
   
            if (selectElement.children[i].selected) {
                listItem.classList.add('is-selected');
            }
        }
   
        var listItems = list.children;
   
        styledSelect.addEventListener('click', function(e) {
            e.stopPropagation();
            document.querySelectorAll('div.select-styled.active').forEach(function(activeStyledSelect) {
                if (activeStyledSelect !== styledSelect) {
                    activeStyledSelect.classList.remove('active');
                    activeStyledSelect.nextElementSibling.style.display = 'none';
                }
            });
            styledSelect.classList.toggle('active');
            list.style.display = styledSelect.classList.contains('active') ? 'block' : 'none';
        });
   
        Array.from(listItems).forEach(function(listItem) {
            listItem.addEventListener('click', function(e) {
                e.stopPropagation();
   
                let optionName = styledSelect.closest('.select').querySelector('select').dataset.optionName;
                if (optionName) {
                    optionName = optionName + ' : ';
                } else {
                    optionName = '';
                }
                styledSelect.innerHTML = `${optionName}${listItem.textContent}<div class="select-styled-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                      <path d="M14.6665 4.66602L7.99984 11.3327L1.33317 4.66602" stroke="white" stroke-width="1.5" stroke-linecap="square"/>
                    </svg></div>`;
   
                styledSelect.classList.remove('active');
                list.style.display = 'none';
   
                selectElement.value = listItem.getAttribute('rel');
   
                let selected = list.querySelector('li.is-selected');
                if (selected) selected.classList.remove('is-selected');
                listItem.classList.add('is-selected');
                selectElement.dispatchEvent(new Event('change', { 'view': window, 'bubbles': true }));
            });
        });
   
        document.addEventListener('click', function() {
            styledSelect.classList.remove('active');
            list.style.display = 'none';
        });
        styledSelect.classList.remove('active');
        list.style.display = 'none';
  });
}
customSelectInit()
document.addEventListener('custom-select:init', customSelectInit)

class CustomSubscriptionWidget extends HTMLElement {
  constructor() {
    super();
    this.oneTime = this.querySelector('[js-one-time-plan]');
    this.subscribe = this.querySelector('[js-subscription-plan]');
    this.bundle = this.querySelector('[js-bundle-plan]');
    this.select = this.querySelector('[js-subscription-widget-select]');
    this.onSellingPlanSelectChange = false;
    
    
  }

  connectedCallback() {
    this?.oneTime?.addEventListener("change", () => this.toggleDetails());
    this?.subscribe?.addEventListener("change", () => this.toggleDetails());
    this?.bundle?.addEventListener("change", () => this.toggleDetails());
    this?.select?.addEventListener("change", () => this.onlyForSubscription());

    console.log('this.subscribe: ', this.subscribe)
    // this.subscribe?.click();
  }

  toggleDetails() {
  const bundleProductInputs = document.querySelectorAll('[js-product-bundle-input]');
  const mainProductInput = document.querySelector('[js-main-product-input]');

  
  let url = this.createUrl();
  if (this.subscribe?.checked) {
    this.select?.setAttribute("name", "selling_plan");
    url = `${url}&selling_plan=${this.select?.value}`;
  } else {
    this.select?.removeAttribute("name");
  }
  if (this.bundle?.checked) {
    bundleProductInputs.forEach(input => input.removeAttribute('disabled'));
    mainProductInput?.setAttribute('disabled', '');
  } else {
    bundleProductInputs.forEach(input => input.setAttribute('disabled', ''));   
    mainProductInput?.removeAttribute('disabled');
  }
  this.renderPrice(url);
}

  createUrl() {
    const sectionId = this.closest('[js-main-product-section]')?.getAttribute('data-section-id');
    const isProductPage = window.location.pathname.includes('/products/');
    const productHandle = this.closest('[js-main-product-section]')?.getAttribute('data-product-handle');

    let baseUrl;
    baseUrl = location.href;

    let url = baseUrl.includes('?')
      ? `${baseUrl}&section_id=${sectionId}`
      : `${baseUrl}?section_id=${sectionId}`;

    if (!isProductPage) {
     url = `${location.origin}${productHandle}?view=page-ajax`;
    }

    return url;
  }

  onlyForSubscription() { 
    let url = this.createUrl();
    url = `${url}&selling_plan=${this.select?.value}`;
     if (this.subscribe?.checked) {
       this.onSellingPlanSelectChange = false;
     } else {
       this.onSellingPlanSelectChange = true;
     }
    this.renderPrice(url);
  } 

  renderPrice(requestUrl) {
    console.log({ requestUrl })
    fetch(requestUrl)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        html.querySelector('overflow-list[defer]')?.removeAttribute('defer');
        
        if (this.onSellingPlanSelectChange) {
          const currentPdpMainSectionPrices = this.querySelectorAll('[js-pdp-section-price]');
          const ajaxPdpMainSectionPrices = html?.querySelector('custom-subscription-widget')?.querySelectorAll('[js-pdp-section-price]');
          
          if(ajaxPdpMainSectionPrices?.length) {
            currentPdpMainSectionPrices.forEach((currentPdpMainSectionPrice, index) => {
              currentPdpMainSectionPrice.replaceWith(ajaxPdpMainSectionPrices[index]);
            })
          }

        } else {
          const currentAtcBtn = document.querySelector('.product-information .Product_information_rightside_new add-to-cart-component');
          const ajaxAtcBtn = html.querySelector('.product-information .Product_information_rightside_new add-to-cart-component');

          console.log('currentAtcBtn', currentAtcBtn?.innerHTML)
          console.log('ajaxAtcBtn', ajaxAtcBtn?.innerHTML)
          
          if(currentAtcBtn && ajaxAtcBtn) {
            currentAtcBtn.replaceWith(ajaxAtcBtn);
          } 

          const currentPdpMainSectionPrices = document.querySelectorAll('.product-information [js-pdp-section-price]');
          const ajaxPdpMainSectionPrices = html.querySelectorAll('.product-information [js-pdp-section-price]');
          if(ajaxPdpMainSectionPrices?.length) {
            currentPdpMainSectionPrices.forEach((currentPdpMainSectionPrice, index) => {
              currentPdpMainSectionPrice.replaceWith(ajaxPdpMainSectionPrices[index]);
            })
          }
        }

        this.onSellingPlanSelectChange = false;

        
        this.mainProductAtcPrices = document.querySelector('[js-atc-product-main-prices]')
        this.mainProductBundlePrices = document.querySelector('[js-atc-product-bundle-prices]')

        if (this.bundle?.checked) {
          if (this.mainProductBundlePrices) this.mainProductBundlePrices.style.display = 'block';
          if (this.mainProductAtcPrices) this.mainProductAtcPrices.style.display = 'none';
        } else {
          if (this.mainProductBundlePrices) this.mainProductBundlePrices.style.display = 'none';
          if (this.mainProductAtcPrices) this.mainProductAtcPrices.style.display = 'block';
        }

      })
  }

}

customElements.define('custom-subscription-widget', CustomSubscriptionWidget);